"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["EN"] = "en-US";
    SupportedLanguages["FR"] = "fr-CA";
    SupportedLanguages["ES"] = "es";
    SupportedLanguages["ES_MX"] = "es-MX";
    SupportedLanguages["EN_CA"] = "en-CA";
    SupportedLanguages["EN_AU"] = "en-AU";
    SupportedLanguages["JA"] = "ja";
    SupportedLanguages["JA_JP"] = "ja-JP";
    SupportedLanguages["ES_US"] = "es-US";
    SupportedLanguages["DE_DE"] = "de-DE";
})(SupportedLanguages = exports.SupportedLanguages || (exports.SupportedLanguages = {}));
exports.LanguageInitMap = {
    englishStrings: SupportedLanguages.EN,
    frenchStrings: SupportedLanguages.FR,
    spanishStrings: SupportedLanguages.ES,
    spanishUnitedStatesStrings: SupportedLanguages.ES_US,
    spanishMexicoStrings: SupportedLanguages.ES_MX,
    englishCanadaStrings: SupportedLanguages.EN_CA,
    englishAustraliaStrings: SupportedLanguages.EN_AU,
    japaneseStrings: SupportedLanguages.JA,
    japaneseJapanStrings: SupportedLanguages.JA_JP,
    germanGermanyStrings: SupportedLanguages.DE_DE,
};
var IntlDateFormatOptions;
(function (IntlDateFormatOptions) {
    IntlDateFormatOptions["NUMERIC"] = "numeric";
    IntlDateFormatOptions["SHORT"] = "short";
    IntlDateFormatOptions["MEDIUM"] = "medium";
    IntlDateFormatOptions["LONG"] = "long";
    IntlDateFormatOptions["FULL"] = "full";
})(IntlDateFormatOptions = exports.IntlDateFormatOptions || (exports.IntlDateFormatOptions = {}));
var DefaultDateTimeFormat = /** @class */ (function () {
    function DefaultDateTimeFormat(value) {
        this.value = value;
    }
    // returns day of week, month, and date in a short form
    // ex: en-US returns "Tue, Apr 13"
    // tslint:disable-next-line:max-line-length
    DefaultDateTimeFormat.DAY_OF_WEEK_MONTH_DATE_SHORT = new DefaultDateTimeFormat({
        weekday: IntlDateFormatOptions.SHORT,
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns day of week, month, and date in a long form.
    // different from "short" because the week and month are fully expanded
    // to their full string representations
    // ex: en-US returns "Tuesday, April 13"
    // tslint:disable-next-line:max-line-length
    DefaultDateTimeFormat.DAY_OF_WEEK_MONTH_DATE_LONG = new DefaultDateTimeFormat({
        weekday: IntlDateFormatOptions.LONG,
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns month, and date in a short form
    // ex: en-US returns "Apr 13"
    DefaultDateTimeFormat.MONTH_DATE_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns month, and date in a long form
    // different from "short" because the month is fully expanded to its
    // full string representation
    // ex: en-US returns "April 13"
    DefaultDateTimeFormat.MONTH_DATE_LONG = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns time in a 12h format
    // ex: en-US returns "10:50 PM"
    DefaultDateTimeFormat.TIME = new DefaultDateTimeFormat({
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        hour12: true,
    });
    // returns time in a 12h format with timezone
    // ex: en-US returns "10:50 PM PST"
    DefaultDateTimeFormat.TIME_WITH_ZONE = new DefaultDateTimeFormat({
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        hour12: true,
        timeZoneName: IntlDateFormatOptions.SHORT,
    });
    // returns date + time in long format
    // ex: en-US returns "April 13, 2021, 8:14 AM PDT"
    DefaultDateTimeFormat.DATE_TIME_LONG = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        hour12: true,
        timeZoneName: IntlDateFormatOptions.SHORT,
    });
    // returns date + time in short format
    // ex: en-US returns "Apr 13, 2021, 8:14 AM"
    DefaultDateTimeFormat.DATE_TIME_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        hour12: true,
    });
    // returns date in long format, time in short format
    // ex: en-US returns "April 13, 2021, 8:14 AM"
    DefaultDateTimeFormat.DATE_LONG_TIME_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        hour12: true,
    });
    // returns date in numeric format
    // ex: en-US returns "4/13/2021"
    DefaultDateTimeFormat.DATE_NUMERIC = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.NUMERIC,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
    });
    return DefaultDateTimeFormat;
}());
exports.DefaultDateTimeFormat = DefaultDateTimeFormat;
